export class DoorWidthAndPhysicalSeparationFactor
{
    id:number;
    regionId:number;
    values:DoorWidthAndPhysicalSeparationFactorValue[];
}
export class DoorWidthAndPhysicalSeparationFactorValue
{
    doorWidthCalculatedId:number;
    noSeparationValue:number;
    oneSeparationValue:number;
    twoSeparationsValue:number;
}